<template>
<b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
  <b-card title="Avis clients">
    <b-button
        href='/rating/add'
        variant="primary"
      >
        + Ajouter un avis client
      </b-button>

       <!-- search input -->
    <div class="custom-search d-flex justify-content-end">
      <b-form-group>
        <div class="d-flex align-items-center">
          <label class="mr-1">Chercher</label>
          <b-form-input
            v-model="searchTerm"
            placeholder="Lunette"
            type="text"
            class="d-inline-block"
          />
        </div>
      </b-form-group>
      
       <b-form-group>
         <div class="d-flex align-items-center">
          <label class="mr-1">&nbsp;Début</label>
          <b-form-datepicker
            id="example-datepicker"
            v-model="beginFilter"
            class="mb-1"
          />
         </div>
       </b-form-group>
       <b-form-group>
          <div class="d-flex align-items-center">
            <label class="mr-1">&nbsp;Fin</label>
            <b-form-datepicker
              id="example-datepicker"
              v-model="endFilter"
              class="mb-1"
            />
          </div>
      </b-form-group>
    </div>
    <!-- table -->
    <vue-good-table
      :columns="columns"
      :rows="ratings"
      :pagination-options="{
        enabled: true,
        perPage:pageLength
      }"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm
      }"
    >
      <template
        slot="table-row"
        slot-scope="props"
      >
        
       
        <!-- Column: Action -->
        <span v-if="props.column.field === 'glass'">
          {{ props.formattedRow[props.column.field].name }}
        </span>
        <span v-else-if="props.column.field === 'action'">
          <span>
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="text-body align-middle mr-25"
                />
              </template>
              <b-dropdown-item  @click="$router.push({name:'editRating', params: { id: props.row.id }})">
                <feather-icon
                  icon="Edit2Icon"
                  class="mr-50"
                />
                <span>Modifier</span>
              </b-dropdown-item>
              <b-dropdown-item v-b-modal.modal-danger @click="selectedItem=props.row.id">
                <feather-icon
                  icon="TrashIcon"
                  class="mr-50"
                />
                <span>Supprimer</span>
              </b-dropdown-item>
            </b-dropdown>
          </span>
        </span>
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>
      <template
        slot="pagination-bottom"
        slot-scope="props"
      >
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap ">
              Page 1 de
            </span>
            <b-form-select
              v-model="pageLength"
              :options="['3','5','10']"
              class="mx-1"
              @input="(value)=>props.perPageChanged({currentPerPage:value})"
            />
            <span class="text-nowrap"> sur {{ props.total }} résultats </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="totalRows"
              v-model="currentPage"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value)=>props.pageChanged({currentPage:value})"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </div>
        </div>
        <b-modal
          id="modal-danger"
          cancel-variant="outline-secondary"
          cancel-title="Non"
          ok-variant="danger"
          ok-title="Oui"
          @ok="deleteRating(selectedItem)"
          modal-class="modal-danger"
          centered
          title="Êtes-vous sûr ?"
        >
          <b-card-text>
            Attention, cette action est irréversible ! Êtes-vous sûr de vouloir supprimer ce point de vente ?
          </b-card-text>
        </b-modal>
      </template>
    </vue-good-table>
  </b-card>
</b-overlay>
</template>

<script>
import {BModal, BButton, BFormDatepicker,VBModal,BOverlay, BCard, BCardText, BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, } from 'bootstrap-vue'
import {APIRequest} from '@simb2s/senseye-sdk'
import { VueGoodTable } from 'vue-good-table'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BCard,
    BCardText,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BOverlay,
    BModal,
    BFormDatepicker,
    BButton
  },
  data() {
    return {
      ratings:[],
      beginFilter:null,
      endFilter:null,
      pageLength: 3,
      totalRows:0,
      currentPage:1,
      loading:true,
      dir: false,
      selectedItem:null,
      columns: [
        {
          label: 'Note',
          field: 'rate',
        },
        {
          label: 'Lunette',
          field: 'glass',
        },
        {
          label: 'Nom',
          field: 'user.name',
        },
        {
          label: 'Email',
          field: 'user.email',
        },
        {
          label: 'Action',
          field: 'action',
        }
        
        
      ],
      rows: [],
      searchTerm: '',

    }
  },
  watch:{
    currentPage:async function(){
      this.loading=true
      let offset=this.currentPage*this.pageLength
      let reviews=await APIRequest.list('reviews', null, null, this.pageLength,offset)
      this.reviews=reviews[0]
      this.loading=false
    },
    endFilter:async function()
    {
      this.loading=true
      let offset=this.currentPage*this.pageLength
      if(this.searchTerm!='' && this.endFilter!=null && this.beginFilter)
      {
        let reviews=await APIRequest.list('reviews', null, null, this.pageLength,offset,null,this.searchTerm,this.beginFilter,this.endFilter)
        this.reviews=reviews[0]
      }
      else if(this.searchTerm!='' && this.endFilter!=null)
      {
        let reviews=await APIRequest.list('reviews', null, null, this.pageLength,offset,null,this.searchTerm,null,this.endFilter)
        this.reviews=reviews[0]
      }
      else if(this.searchTerm!='')
      {
        let reviews=await APIRequest.list('reviews', null, null, this.pageLength,offset,null,this.searchTerm)
        this.reviews=reviews[0]
      }
      else
      {
        let reviews=await APIRequest.list('reviews', null, null, this.pageLength,offset)
        this.reviews=reviews[0]
      }
      
      this.loading=false
    },
    beginFilter:async function()
    {
      this.loading=true
      let offset=this.currentPage*this.pageLength
      if(this.searchTerm!='' && this.endFilter!=null && this.beginFilter)
      {
        let reviews=await APIRequest.list('reviews', null, null, this.pageLength,offset,null,this.searchTerm,this.beginFilter,this.endFilter)
        this.reviews=reviews[0]
      }
      else if(this.searchTerm!='' && this.endFilter!=null)
      {
        let reviews=await APIRequest.list('reviews', null, null, this.pageLength,offset,null,this.searchTerm,null,this.endFilter)
        this.reviews=reviews[0]
      }
      else if(this.searchTerm!='')
      {
        let reviews=await APIRequest.list('reviews', null, null, this.pageLength,offset,null,this.searchTerm)
        this.reviews=reviews[0]
      }
      else
      {
        let reviews=await APIRequest.list('reviews', null, null, this.pageLength,offset)
        this.reviews=reviews[0]
      }
      this.loading=false
    }
  },
  methods:{
    async deleteRating(id)
    {
      this.loading=true
      try {
        await APIRequest.delete('reviews',id)
        let ratings=await APIRequest.list('reviews')
        this.ratings=ratings[0]
        this.totalRows=ratings[1]
        this.loading=false
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "L'avis client a été supprimé !",
            icon: 'CheckIcon',
            variant: 'success',
          },
        })
        
      } catch (error) {
        this.loading=false
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Une erreur est survenue.',
            icon: 'AlertCircleIcon',
            variant: 'warning',
          },
        })
        
      }
      
    }
  },
  async mounted()
  {
    let ratings=await APIRequest.list('reviews')
    this.ratings=ratings[0]
     this.totalRows=ratings[1]
    this.loading=false
  }
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
